export type FeatureFlags =
    | {
          candyTestFeature?: string;
          showDraftHistoryInEditor?: boolean;
      }
    | {
          [data: string]: unknown;
      };

export const featureFlagQueryParamPrefix = "ff.";
